export default class FrontEndSettingsModel {
    groupListOpen = true
    includeArchived = false
    lastVBITLogSeen = process.env.VUE_APP_VERSION

    public constructor(data: null | string) {
        if (!!data) {
            let dataParsed = JSON.parse(data)
            this.groupListOpen = dataParsed.groupListOpen ? dataParsed.groupListOpen : true
            this.includeArchived = dataParsed.includeArchived ? dataParsed.includeArchived : false
            this.lastVBITLogSeen = dataParsed.lastVBITLogSeen
                ? dataParsed.lastVBITLogSeen
                : process.env.VUE_APP_VERSION
        }
    }
}
